import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {FileService} from 'src/app/services/file.service';
import MyEditor from 'ckeditor5-custom-build/build/ckeditor';
import {SessionService, UserType} from 'src/app/services/session.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  private params: Params;
  datasetId = 0;
  forumId = 0;
  forum: any = false;
  isReady = false;
  devMode = false;
  elements: any = [];
  message = '';
  inProgress = false;
  enterpriseUser = null;

  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };
  public Editor = MyEditor;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private trustiiService: TrustiiService,
              private dataservice: DataService,
              public fileService: FileService,
              private sessionService: SessionService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.datasetBannerModel.setBannerView(DatasetBannerView.ForumView);

    this._loadParams$()
      .pipe(
        switchMap(this._loadForum$.bind(this)),
        tap(this.getMessages.bind(this))
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.params
      .pipe(
        map((params: Params) => this.params = params)
      );
  }

  /** _loadForum$ method
   *
   * Load forum if there is id forum on params.
   */
  private _loadForum$(): Observable<any> {
    if (!this.params.forumId || this.params.forumId <= 0 || !this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;
    this.forumId = this.params.forumId;
    return this.trustiiService.getForum(this.datasetId, this.forumId)
      .pipe(
        map((forum: any) => this.forum = forum.data),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  /**
   * Get messages
   */
  getMessages(): void {
    this.isReady = false;
    this.elements = [];
    this.trustiiService.getForumMessages(this.datasetId, this.forumId, this.meta.page, this.meta.per_page).subscribe(
      (res) => {
        this.elements = res.data;
        this.meta = res.meta;
        this.isReady = true;
      },
      (err) => {
        this.isReady = true;
        this.elements = [];
      }
    );
  }

  postMessage(): void {
    if (this.message.trim() === '') {
      return;
    }

    this.inProgress = true;
    const payload = {
      message: this.message,
    };

    this.trustiiService.postForumMessage(this.datasetId, this.forumId, payload).subscribe(
      (res) => {
        this.inProgress = false;
        this.message = '';
        this.getMessages();
      }, (err) => {
        this.inProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          'failed to post a new message',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getMessages();
  }

  /**
   * When page changed
   *
   * @param page The page
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getMessages();
  }

  /**
   * Format date
   *
   * @param stringDate The date
   * @return Local date
   */
  formatDate(stringDate: string): string {
    const date = new Date(stringDate);
    return date.toLocaleString();
  }
}
